/**
 * YouTube'daki müşteri başarı hikayesi videoları (youtube.com/@dijipoagency).
 * Küçük resimler i.ytimg.com'dan tembel yüklenir; iframe yalnızca tıklanınca
 * (youtube-nocookie) yüklenir, böylece PageSpeed etkilenmez.
 */
export interface VideoKanit {
  /** YouTube video kimliği */
  id: string;
  /** Kartta görünen kısa başlık (müşterinin cümlesi) */
  baslik: string;
  /** Marka / kişi */
  marka: string;
  /** YouTube'daki tam başlık (JSON-LD name) */
  tamBaslik: string;
  /** ISO 8601 süre */
  sure: string;
  /** Görünen süre */
  sureEtiket: string;
  /** Açıklama (JSON-LD description + alt metin) */
  aciklama: string;
  /** YouTube yüklenme tarihi (ISO 8601, YouTube sayfasından) — VideoObject uploadDate */
  yuklenme: string;
  /** Vaka/referans bağlantısı (varsa) */
  link?: { href: string; etiket: string };
}

export const YOUTUBE_KANAL = "https://www.youtube.com/@dijipoagency";

export const VIDEO_KANITLAR: VideoKanit[] = [
  {
    id: "yRG7imaBwsQ",
    yuklenme: "2024-11-14",
    baslik: "Her sorumuza anında cevap alıyoruz",
    marka: "Bermody",
    tamBaslik: "Her Sorumuza Anında Cevap Alıyoruz! - Bermody | Başarı Hikayeleri | Dijipo",
    sure: "PT1M3S",
    sureEtiket: "1:03",
    aciklama: "Ayakkabı markası Bermody, Dijipo ile çalışma deneyimini anlatıyor: hızlı iletişim, reklam yönetimi ve e-ticaret büyümesi.",
  },
  {
    id: "jiCVf5UN1ME",
    yuklenme: "2024-11-20",
    baslik: "Tüm problemlerimiz hızla çözülüyor",
    marka: "By Selma Özkan",
    tamBaslik: "Tüm Problemlerimiz Hızla Çözülüyor! - By Selma Özkan | Başarı Hikayeleri | Dijipo",
    sure: "PT1M15S",
    sureEtiket: "1:15",
    aciklama: "By Selma Özkan markası, Dijipo ile e-ticaret ve reklam süreçlerinde sorunların nasıl hızla çözüldüğünü anlatıyor.",
  },
  {
    id: "-l9r8ptNUss",
    yuklenme: "2024-11-14",
    baslik: "Tüm beklentilerimiz en iyi şekilde karşılanıyor",
    marka: "Brunch Plus",
    tamBaslik: "Tüm Beklentilerimiz En İyi Şekilde Karşılanıyor! - Brunch Plus | Başarı Hikayeleri | Dijipo",
    sure: "PT1M3S",
    sureEtiket: "1:03",
    aciklama: "Brunch Plus, Dijipo ile çalışırken beklentilerinin nasıl karşılandığını ve e-ticaret operasyonundaki deneyimini paylaşıyor.",
  },
  {
    id: "G2a31CQWjrE",
    yuklenme: "2024-11-14",
    baslik: "Dijipo tüm ihtiyaçlarımızı karşıladı",
    marka: "Mira Kids",
    tamBaslik: "Dijipo Tüm İhtiyaçlarımızı Karşıladı! - Mira Kids | Başarı Hikayeleri | Dijipo",
    sure: "PT1M14S",
    sureEtiket: "1:14",
    aciklama: "Çocuk giyim markası Mira Kids, e-ticaret kurulumu ve reklam yönetiminde Dijipo ile çalışma deneyimini anlatıyor.",
  },
];

export const videoUrl = (id: string) => `https://www.youtube.com/watch?v=${id}`;
export const videoKapak = (id: string) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
